export enum TrackerPhase {
    'START' = 'START',
    'END' = 'END',
    'ANOTHER' = 'ANOTHER',
    'COMPLETED' = 'COMPLETED',
    'NA' = 'NA'
}
